const rankList = 'webranking/gameRanking';

const awardRankList = 'webranking/award';
export {
  rankList,
  awardRankList
}